// Render Checkbox element to change user default dispatch schedule preference
import { useFormContext } from 'react-hook-form';

import { DispatchScheduleFormContextData } from '@/components/DispatchSchedule/DispatchScheduleForm';

export default function SetAsDefaultScheduleCheckbox() {
  const { register } = useFormContext<DispatchScheduleFormContextData>();

  return (
    <div className="flex">
      <label className="clickable label basis-2/12 justify-start">
        <input
          type="checkbox"
          className="checkbox-primary checkbox border-base-300 mr-2"
          {...register('isUserDefaultSchedule')}
        />
        <span className="label-text">Choose this Schedule by default</span>
      </label>
    </div>
  );
}
